import { Divider, Stack } from '@mantine/core';

import { ArticleProofAction } from '@/module/Author/Article/Proof/ArticleProofAction';
import { ArticleValidationAction } from '@/module/Author/Article/Validation/ArticleValidationAction';
import { ArticleValidationHistory } from '@/module/Author/Article/Validation/ArticleValidationHistory';
import { ArticleDeleteButton } from '@/module/Author/Article/components/ArticleDeleteButton';
import { ArticleImpactFactor } from '@/module/Author/Article/components/ArticleImpactFactor';
import { ArticleInfluence } from '@/module/Author/Article/components/ArticleInfluence';
import { PaperContent } from '@/module/Author/Paper/components/PaperContent';
import { PublicationContent } from '@/module/Author/Publication/components/PublicationContent';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList, WosIndexAs } from '@feature/utils';

import { ViewCitationsButton } from '../Citation/components/ViewCitationsButton';
import { Article } from './model/ArticleTypes';

interface ArticleViewProps {
  article: Article;
}

export function ArticleView({ article }: ArticleViewProps) {
  const { authors, type, universityAffiliatedNoOfAuthors, noOfRoAuthors } = article;

  return (
    <Stack>
      <PublicationContent
        publication={article}
        authorsNo={authors.length}
        titlePre={<WosIndexAs type={type} />}
        editAction={
          <EditButtonLink
            size="xs"
            miw="100px"
          />
        }
        deleteAction={<ArticleDeleteButton articleId={article.id} />}
      />
      <ViewCitationsButton
        entityId={article.id}
        entityType="ARTICLE"
      />
      <PaperContent
        paper={article}
        metrics={
          <Stack>
            <ArticleImpactFactor articleId={article.id} />
            <Divider my="10px" />
            <ArticleInfluence articleId={article.id} />
          </Stack>
        }
      />
      <Content type="full">
        <AuthorList
          authors={authors}
          affiliatedNo={universityAffiliatedNoOfAuthors}
          noOfRoAuthors={noOfRoAuthors}
        />
      </Content>
      <ArticleProofAction
        articleId={article.id}
        authors={authors}
      />
      <ArticleValidationAction articleId={article.id} />
      <ArticleValidationHistory articleId={article.id} />
    </Stack>
  );
}
